import styled from 'styled-components';

export const Container = styled.ul`
  .nav-link {
    background-color: transparent;
    color: ${(props) => props.theme.$gray600} !important;
  }

  .material-icons {
    font-size: 18px;
  }
`;
